import { Component, OnInit, AfterViewInit, ViewChild, ViewEncapsulation, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { DashboardFilter } from './../../../models/DashboardFilter';
import { CPPPriceListFilter } from './../../../models/CPP/CPPPriceListFilter';
import * as $ from 'jquery';
import { saveAs } from 'file-saver';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { CommonService } from './../../../services/common/common.service';
import { CppPriceListService } from './../../../services/cpp/cpp-price-list.service';
import { MasterConstants } from './../../../common/constants/master-constants';
import { ConfirmDialogComponent } from './../../../common/components/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { CppManageSubscription } from '../../../services/cpp/cpp-price-list-manage-subscription.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-cpp-price-list-dashboard',
  templateUrl: './cpp-price-list-dashboard.component.html',
  styleUrls: ['./cpp-price-list-dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CppPriceListDashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  public cppProductListDataSource: MatTableDataSource<any>;
  mainProductList: any = [];
  cppProductList: any = [];
  headerCompany = MasterConstants.US_COMPANYCODE;
  dashboardFilter: DashboardFilter;
  productNameInput = '';
  priceListCPPColumns: string[] = ['checkbox', 'product', 'terms', 'dec', 'jan', 'feb', 'mar', 'apr', 'may', 'priceChange2', 'price', 'contextMenu'];
  searchTypeList = ['Product Name', 'Product Number', 'Product Line', 'Product Category', 'Supplier', 'Change Since', 'Product Brand', 'Pack Size'];
  readOnlyAccess = false;
  selectedValue: string = this.searchTypeList[0];
  filterValueList = new Array();
  productFilters: CPPPriceListFilter = new CPPPriceListFilter();
  filter: CPPPriceListFilter = new CPPPriceListFilter();
  isPriceListDisplayed = false;
  isSpecialPriceListDisplayed = false;
  isShowChangesOnly = false;
  selectedFilter: any;
  selectedCount = 0;
  isSearchClicked: any;
  tabNode: boolean;
  editToolKit = false;
  allChecked = false;
  priceListFilter: CPPPriceListFilter = new CPPPriceListFilter();
  priceChangeCount = 0;
  priceChangeCountCustomerSpecific = 0;
  accountNo = 0;
  accountName: string;
  @ViewChild('productListPaginator', { read: MatPaginator }) productListPaginator: MatPaginator;
  totalRows = 0;
  pageIndex = 0;
  viewAllFilters = false;
  displayHideAll = true;
  dateFilter: any;
  maxDate = new Date();
  retainChangeSince = false;
  lastSaturday: any;
  isChangeSinceValid = true;
  isLoading = true;
  isStatus: string;
  subscriptionType = 'A';
  displayAPR = 'Y';
  changesOnly = 'N';
  changeType = 'Term Or Price';
  isShowClick = false;
  isManageSubAccess = false;
  isSubsModalShow = false;
  subscriptionTypeFlag: string;
  changesOnlyFlag: string;
  isOwnerPriceListAccess: string = "N";
  isTermChangeOnly: boolean = false;
  isPriceChangeOnly: boolean = false;
  termchangesOnly: string = "N";
  pricechangesOnly: string = "N";
  masterConstants = MasterConstants;
  checked = false;
  displayItem = 'all';
  displayText: string = 'ALL ITEMS';
  mySubscriptionDisplayItemToggle = 'all';
  disableFilterBtn = true;
  productNameSearchList: Array<any> = [];

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private matDialog: MatDialog,
    private toastrService: ToastrService,
    private datePipe: DatePipe,
    private cppPriceListService: CppPriceListService,
    private cppManageSubscription: CppManageSubscription,
    private cd: ChangeDetectorRef,
    private commonService: CommonService
  ) {
    this.dashboardFilter = new DashboardFilter();

    // Set account number if passed in url

    this.subscription.push(this.activeRoute.params.subscribe(params => {
      const id = params['accountNo'];
      this.accountNo = id ? id : 0;
    }));
  }
  // Page initilization code
  ngOnInit() {
    this.accountName = this.cppPriceListService.accountName;
    this.resetProductFilter();
    this.getSubscriptionStatus();

    this.subscription.push(this.cppPriceListService.ownerPriceListAccessPermission(this.accountNo).subscribe(result => {
      this.isOwnerPriceListAccess = result.data[0];
    }));

    if (this.localStorageService.get(MasterConstants.CPP_PRICELIST_PRODNAME_SEARCH_OPTIONS)) {
      this.productNameSearchList = JSON.parse(this.localStorageService.get(MasterConstants.CPP_PRICELIST_PRODNAME_SEARCH_OPTIONS));
      this.productNameSearchList = this.productNameSearchList.map(a => a.id);
    }

    this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);
    this.loadMasterData();
    this.getCPPProductData();

    if (this.termchangesOnly == 'N' && this.pricechangesOnly == 'N') {
      this.changesOnly = 'N';
    }
  }
  // Called after component view is fully initialized isSpecialPriceListDisplayed
  ngAfterViewInit() {
    this.setPriceListTableHeight();
  }

  validateDateFilter() {
    this.dateFilter = (d: Date): boolean => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      const calendarDate = d;

      return calendarDate >= currentDate;
    };
  }
  // Show/Hide Product Detail section
  showDetails(event: UIEvent, element, column): void {
    element.selected = column.toString();
  }

  // Update the page number on click of next/previous
  public updatePage(event?: PageEvent) {
    $('.example-detail-row').remove();
    const list = document.getElementsByClassName('mat-mdc-paginator-range-label');
    const totalPages = this.totalRows / 250;
    if (event) {
      this.pageIndex = event && event.pageIndex;
      const newPage = (this.pageIndex + 1).toString();
      const displayValue = 'Page: ' + newPage + ' of ' + Math.ceil(totalPages);
      list[0].innerHTML = displayValue;
    } else {
      list[0].innerHTML = 'Page: ' + 0 + ' of ' + Math.ceil(totalPages);
    }
    $('tr[id*=\'tr_col_\']').remove();
  }

  // Reset the filter values
  public resetProductFilter() {
    this.filterValueList = [];
    this.productFilters = {
      'accountNo': 0,
      'productName': '',
      'productNumber': [],
      'productLine': [],
      'packageSize': [],
      'productCategory': [],
      'supplier': [],
      'changedPrices': [],
      'changedTerms': [],
      'productBrand': [],
      'isGroup': false,
      'changeSinceDate': null
    };
  }
  // Load filter data
  loadMasterData() {
    this.subscription.push(this.cppPriceListService.getCPPFilterData(this.accountNo).subscribe((result: any) => {
      this.priceListFilter = {
        changedPrices: result.changedPrices,
        changedTerms: result.changedTerms,
        packageSize: result.packageSize,
        productBrand: result.productBrand,
        productCategory: result.productCategory,
        productLine: result.productLine,
        productName: result.productName,
        productNumber: result.productNumber,
        supplier: result.supplier,
        isGroup: false,
        accountNo: 0,
        changeSinceDate: null
      };
      this.accountName = result.accountName;
      this.lastSaturday = result.changeSinceDate;
    }));
  }

  // Enable/Disable single checkbox in each row of the table
  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.isSearchClicked = false;
      this.selectedCount = this.selectedCount + 1;
      const checked = this.cppProductListDataSource.data.filter(x => x.isSelected == false);
      if (checked && checked.length == 0) {
        this.allChecked = true;
      }
      else {
        this.allChecked = false;
      }
    }
    else {
      this.selectedCount = this.selectedCount - 1;
      this.allChecked = false;
    }
    const checked = this.cppProductListDataSource.data.filter(x => x.isSelected === true);
    if (checked) {
      this.editToolKit = (checked.length > 0);
    }
  }

  // Enable/Disable checkbox on top of the table for all rows
  enableAllCheckBoxes(isChecked) {
    if (isChecked) {
      this.isSearchClicked = false;
      this.cppProductListDataSource.data.forEach(x => {
        x.isSelected = true;
      });
      this.selectedCount = this.cppProductListDataSource.data.length;
    }
    else {
      this.cppProductListDataSource.data.forEach(x => {
        x.isSelected = false;
      });
      this.selectedCount = 0;
    }
    const checked = this.cppProductListDataSource.data.filter(x => x.isSelected === true);
    if (checked) {
      this.editToolKit = (checked.length > 0);
    }
  }

  // Set Table height dynamically
  setPriceListTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.topSection').outerHeight() - 125;
      $('.priceListTable').css('max-height', templateHeight + 'px');
    }, 100);
  }

  // Show Product Detail section on click
  showProductDetails(item) {
    const rowNo = item.rowNo;
    if ($('#btn_' + rowNo + ' i').hasClass('fa-ellipsis-v')) {
      $('#btn_' + rowNo + ' i').removeClass('fa-ellipsis-v margin-l15').addClass('fa-times');
      const expandRow = `<tr id="tr_col_${rowNo}" _ngcontent-c17=""class="example-detail-row mat-row ng-star-inserted" mat-row="" role="row">
                  <td _ngcontent-c17="" class="product-details mat-cell cdk-column-expandedDetail mat-column-expandedDetail ng-star-inserted" mat-cell="" role="gridcell" colspan="13">
                    <div _ngcontent-c17="" class="ng-star-inserted" style="display: block;">
                       <div _ngcontent-c17="" class="cpp-prod-info">
                        <table _ngcontent-c17="" style="width:100%">
                            ${this.getRowsHtml(item)}
                          </table>
                        </div>
                    </div>
                  </td>
                </tr>`;

      //add row
      $('#tr_exp_' + rowNo).after(expandRow);
    }
    else {
      $('#tr_col_' + rowNo).remove();
      $('#btn_' + rowNo + ' i').removeClass('fa-times').addClass('fa-ellipsis-v margin-l15');
    }
  }

  getRowsHtml(item): string {
    let rowsHtml: string = '';

    if (this.headerCompany === this.masterConstants.US_COMPANYCODE) {
      rowsHtml = `<thead _ngcontent-c17="">
        <tr _ngcontent-c17="">
            <th _ngcontent-c17="" width="15%" class="text-left">Product Number</th>
            <th _ngcontent-c17="" width="16%">Restricted Use</th>
            <th _ngcontent-c17="" width="19%">Non-Returnable</th>
            <th _ngcontent-c17="" width="19%">Pallet Quantity</th>
            <th _ngcontent-c17="" width="16%">Historical Supplier</th>
            <th _ngcontent-c17="" width="15%" class="text-right">Dividend Lane</th>
          </tr>
        </thead>
        <tbody _ngcontent-c17="">
        <tr _ngcontent-c17="">
            <td _ngcontent-c17="" width="17%" class="text-left"><p>${item.itemNo}</p></td>
            <td _ngcontent-c17="" width="16%"><p>${item.rup == "Y" ? "Yes" : ""}</p></td>
            <td _ngcontent-c17="" width="19%"><p>${item.returnable == "N" ? "X" : ""}</p></td>
            <td _ngcontent-c17="" width="19%"><p>${item.palletQuantity ? item.palletQuantity.toFixed(4) : '0.0000'}</p></td>
            <td _ngcontent-c17="" width="16%"><p>${item.historySupplier}</p></td>
            <td _ngcontent-c17="" width="15%" class="text-center padding-l60"><p>${item.dividendLane}</p></td>
          </tr>
        </tbody>`;
    } else {
      rowsHtml = `<thead _ngcontent-c17="">
          <tr _ngcontent-c17="">
            <th _ngcontent-c17="" width="15%" class="text-left">Product Number</th>
            <th _ngcontent-c17="" width="16%">Rebill Eligible</th>
            <th _ngcontent-c17="" width="19%">GST Eligible</th>
            <th _ngcontent-c17="" width="19%">Prepay Eligible</th>
            <th _ngcontent-c17="" width="16%">CPO Eligible</th>
            <th _ngcontent-c17="" width="15%" class="text-right">Return Eligible </th>
          </tr>
        </thead>
        <tbody _ngcontent-c17="">
        <tr _ngcontent-c17="">
            <td _ngcontent-c17="" width="17%" class="text-left"><p>${item.itemNo}</p></td>
            <td _ngcontent-c17="" width="16%"><p>${item.reBillEligible == "Y" ? "Y" : "N"}</p></td>
            <td _ngcontent-c17="" width="19%"><p>${item.gsteligible == "Y" ? "Y" : "N"}</p></td>
            <td _ngcontent-c17="" width="19%"><p>${item.prepayEligible == "Y" ? "Y" : "N"}</p></td>
            <td _ngcontent-c17="" width="16%"><p>${item.cpcoelgibile == "Y" ? "Y" : "N"}</p></td>
            <td _ngcontent-c17="" width="15%" class="text-center padding-l60"><p>${item.returnable == "Y" ? "Y" : "N"}</p></td>
          </tr>
        </tbody>`;
    }

    return rowsHtml;
  }

  // Toggle method for Your Price and APR view
  toggleDisplay() {
    this.loaderService.setLoaderStatus(true);
    setTimeout(() => {
      this.isPriceListDisplayed = !this.isPriceListDisplayed;
      $('.example-detail-row').remove();
      if (this.isPriceListDisplayed) {
        this.priceListCPPColumns = ['checkbox', 'product', 'priceChange', 'terms', 'dec', 'jan', 'feb', 'mar', 'apr', 'may', 'price', 'contextMenu'];
      } else {
        this.priceListCPPColumns = ['checkbox', 'product', 'terms', 'dec', 'jan', 'feb', 'mar', 'apr', 'may', 'priceChange2', 'price', 'contextMenu'];
      }
      this.loaderService.setLoaderStatus(false);
    }, 1000);
  }

  toggleSpecialItemDisplay() {
    this.loaderService.setLoaderStatus(true);
    this.isSpecialPriceListDisplayed = !this.isSpecialPriceListDisplayed;
    this.toggleProductViewData();
  }

  // Toggle method for All items and Special items
  triToggleSpecialItemDisplay() {
    this.loaderService.setLoaderStatus(true);
    if (this.displayItem == 'all') {
      this.displayItem = 'special';
      this.displayText = 'SPECIAL PRICED ITEMS';
    } else if (this.displayItem == 'special') {
      this.displayItem = 'favorite';
      this.displayText = 'FAVORITE ITEMS';
    } else if (this.displayItem == 'favorite') {
      this.displayItem = 'all';
      this.displayText = 'ALL ITEMS';
    }
    this.cd.detectChanges();
    this.toggleProductViewData();
  }

  // Toggle method for All items and Special items
  toggleShowChangesOnly() {
    this.loaderService.setLoaderStatus(true);
    this.isShowChangesOnly = !this.isShowChangesOnly;
    if (this.isShowChangesOnly) {
      this.isTermChangeOnly = true;
      this.isPriceChangeOnly = true;
    }
    else {
      this.isTermChangeOnly = false;
      this.isPriceChangeOnly = false;
    }
    this.toggleProductViewData();
  }

  // Populate table data on basis of national priceretainFilter
  toggleProductViewData() {
    if (this.headerCompany == this.masterConstants.US_COMPANYCODE) {
      $('.example-detail-row').remove();
      this.cppProductList.forEach(function (value) {
        $('#btn_' + value.rowNo + ' i').removeClass('fa-times').addClass('fa-ellipsis-v margin-l15');
      });
      if (this.displayItem == 'special' && this.isShowChangesOnly) {
        this.cppProductList = this.mainProductList.filter(x => x.isNational == false && (x.priceFlag === 'Y' || x.termFlag === 'Y' || x.rplPriceFlag === 'Y' || x.rplTermFlag === 'Y' || x.nplPriceFlag === 'Y' || x.nplTermFlag === 'Y'));
      }
      else if (this.displayItem == 'favorite' && this.isShowChangesOnly) {
        this.cppProductList = this.mainProductList.filter(x => x.isFavoriteItem == true && (x.priceFlag === 'Y' || x.termFlag === 'Y' || x.rplPriceFlag === 'Y' || x.rplTermFlag === 'Y' || x.nplPriceFlag === 'Y' || x.nplTermFlag === 'Y'));
      }
      else if (this.isShowChangesOnly && this.isPriceChangeOnly && this.isTermChangeOnly) {
        this.cppProductList = this.mainProductList.filter(x => x.priceFlag === 'Y' || x.termFlag === 'Y' || x.rplPriceFlag === 'Y' || x.rplTermFlag === 'Y' || x.nplPriceFlag === 'Y' || x.nplTermFlag === 'Y');
      }
      else if (this.displayItem == 'special') {
        this.cppProductList = this.mainProductList.filter(x => x.isNational == false && x.custNo != 0);
      }
      else if (this.displayItem == 'favorite') {
        this.cppProductList = this.mainProductList.filter(x => x.isFavoriteItem == true);
      }
      else {
        this.cppProductList = this.mainProductList;
      }
    }
    else {
      $('.example-detail-row').remove();
      this.cppProductList.forEach(function (value) {
        $('#btn_' + value.rowNo + ' i').removeClass('fa-times').addClass('fa-ellipsis-v margin-l15');
      });
      if (this.isSpecialPriceListDisplayed && this.isShowChangesOnly) {
        this.cppProductList = this.mainProductList.filter(x => x.isNational == false && (x.priceFlag === 'Y' || x.termFlag === 'Y' || x.rplPriceFlag === 'Y' || x.rplTermFlag === 'Y' || x.nplPriceFlag === 'Y' || x.nplTermFlag === 'Y'));
      }
      else if (this.isShowChangesOnly && this.isPriceChangeOnly && this.isTermChangeOnly) {
        this.cppProductList = this.mainProductList.filter(x => x.priceFlag === 'Y' || x.termFlag === 'Y' || x.rplPriceFlag === 'Y' || x.rplTermFlag === 'Y' || x.nplPriceFlag === 'Y' || x.nplTermFlag === 'Y');
      }
      else if (this.isSpecialPriceListDisplayed) {
        this.cppProductList = this.mainProductList.filter(x => x.isNational == false && x.custNo != 0);
      }
      else {
        this.cppProductList = this.mainProductList;
      }
    }

    if (this.mainProductList && this.mainProductList.length > 0) {
      this.priceChangeCount = this.mainProductList[0].changeCount;
      this.priceChangeCountCustomerSpecific = this.mainProductList[0].changeCountCustomerSpecific;
    }
    this.SetDataByPage();

    this.selectedCount = this.cppProductListDataSource.data.filter(x => x.isSelected === true).length;
  }

  filterDataForTermChangeOnly() {
    this.isTermChangeOnly = !this.isTermChangeOnly;
    if (this.isTermChangeOnly == false && this.isPriceChangeOnly == false) {
      this.isShowChangesOnly = false;
    }
    if (this.isShowChangesOnly && this.isTermChangeOnly && !this.isPriceChangeOnly) {
      this.cppProductList = this.mainProductList.filter(x => x.termFlag === 'Y' || x.rplTermFlag === 'Y' || x.nplTermFlag === 'Y');
      this.SetPriceChangeCount(this.cppProductList);
    }
    else if (!this.isTermChangeOnly && this.isPriceChangeOnly && this.isShowChangesOnly) {
      this.cppProductList = this.mainProductList.filter(x => x.priceFlag === 'Y' || x.rplPriceFlag === 'Y' || x.nplPriceFlag === 'Y');
      this.SetPriceChangeCount(this.cppProductList);
    }
    else {
      this.toggleProductViewData();
    }

    this.SetDataByPage();
  }

  filterDataForPriceChangeOnly() {
    this.isPriceChangeOnly = !this.isPriceChangeOnly;
    if (this.isTermChangeOnly == false && this.isPriceChangeOnly == false) {
      this.isShowChangesOnly = false;
    }
    if (this.isShowChangesOnly && this.isPriceChangeOnly && !this.isTermChangeOnly) {
      this.cppProductList = this.mainProductList.filter(x => x.priceFlag === 'Y' || x.rplPriceFlag === 'Y' || x.nplPriceFlag === 'Y');
      this.SetPriceChangeCount(this.cppProductList);
    }
    else if (!this.isPriceChangeOnly && this.isTermChangeOnly && this.isShowChangesOnly) {
      this.cppProductList = this.mainProductList.filter(x => x.termFlag === 'Y' || x.rplTermFlag === 'Y' || x.nplTermFlag === 'Y');
      this.SetPriceChangeCount(this.cppProductList);
    }
    else {
      this.toggleProductViewData();
    }

    this.SetDataByPage();
  }

  SetPriceChangeCount(productList: any) {
    const uniqueRecords = productList.map(item => item.itemId).filter((value, index, self) => self.indexOf(value) === index);
    this.priceChangeCount = uniqueRecords.length;
    const customerSpecificRecords = productList.map(item => item.itemId && !item.isNational).filter((value, index, self) => self.indexOf(value) === index);
    this.priceChangeCountCustomerSpecific = customerSpecificRecords.length;
  }

  SetDataByPage() {
    this.totalRows = this.cppProductList.length;
    this.cppProductListDataSource = new MatTableDataSource(this.cppProductList);
    this.cppProductListDataSource.paginator = this.productListPaginator;
    this.productListPaginator.firstPage();
    $('.mat-mdc-paginator-page-size').hide();
    const list = document.getElementsByClassName('mat-mdc-paginator-range-label');
    const currentPage = this.totalRows > 0 ? 1 : 0;
    list[0].innerHTML = 'Page: ' + currentPage + ' of ' + Math.ceil((this.totalRows / 250));
    setTimeout(() => {
      this.loaderService.setLoaderStatus(false);
    }, 1000);
  }

  // Get Cpp Product list
  getCPPProductData() {
    this.editToolKit = false;
    this.selectedCount = 0;
    this.loaderService.setLoaderStatus(true);
    this.productFilters.accountNo = this.accountNo;
    if (this.priceListFilter.changeSinceDate != null) {
      this.retainChangeSince = true;
      if (this.isValidDate(this.datePipe.transform(this.priceListFilter.changeSinceDate, 'MM/dd/yyyy'))) {
        // this.isShowChangesOnly = true;
        this.productFilters.changeSinceDate = new Date(this.productFilters.changeSinceDate).toDateString();
      }
      else {
        this.toastrService.error('Invalid Date Format.');
        this.loaderService.setLoaderStatus(false);
        this.retainChangeSince = false;
        return false;
      }
    }
    else {
      if (!this.isChangeSinceValid) {
        this.toastrService.error('Invalid Date Format.');
        this.loaderService.setLoaderStatus(false);
        return false;
      }
      this.retainChangeSince = false;
      this.productFilters.changeSinceDate = null;
    }

    this.subscription.push(this.cppPriceListService.getCPPProductData(this.productFilters).subscribe((result: any[]) => {
      $('.example-detail-row').remove();
      this.mainProductList = result;
      this.datePipe.transform;
      this.mainProductList.forEach((element, i) => {
        element.rowNo = i;
        element.priceFlagCount = 0;

        element.toolTip = [];
        if (element.priceFlag === 'Y') {
          element.priceFlagCount = 1;
          element.toolTip.push('Customer Price: ' + this.datePipe.transform(new Date(element.priceAsOfDate), 'MM/dd/yyyy'));
        }
        if (element.termFlag === 'Y') {
          element.priceFlagCount += 1;
          element.toolTip.push('Customer Term: ' + this.datePipe.transform(new Date(element.termsEffective), 'MM/dd/yyyy'));
        }
        if (element.rplPriceFlag === 'Y') {
          element.priceFlagCount += 1;
          element.toolTip.push('Region Price: ' + this.datePipe.transform(new Date(element.rplPriceAsOfDate), 'MM/dd/yyyy'));
        }
        if (element.rplTermFlag === 'Y') {
          element.priceFlagCount += 1;
          element.toolTip.push('Region Term: ' + this.datePipe.transform(new Date(element.rplTermsEffective), 'MM/dd/yyyy'));
        }
        if (element.nplPriceFlag === 'Y') {
          element.priceFlagCount += 1;
          element.toolTip.push('National Price: ' + this.datePipe.transform(new Date(element.nplPriceAsOfDate), 'MM/dd/yyyy'));
        }
        if (element.nplTermFlag === 'Y') {
          element.priceFlagCount += 1;
          element.toolTip.push('National Term: ' + this.datePipe.transform(new Date(element.nplTermsEffective), 'MM/dd/yyyy'));
        }
      });
      this.toggleProductViewData();
    }, error => {
      this.loaderService.setLoaderStatus(false);
      LolLoggerService.info(error);
    }));
  }
  // For the row that needs to be highlighted as group header
  isGroup(index, item): boolean {
    return item.isGroup;
  }
  // For the row that lie inside a group
  isNotGroup(index, item): boolean {
    return !item.isGroup;
  }
  // Clear selected filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      this.displayHideAll = this.filterValueList.length > 8 ? true : false;
      // remove product filter
      this.removeSelectedFilter(filterValue);
    }
  }

  // Retain Filter Value
  retainFilter(selectedObj: any, type: string) {
    if (this.filterValueList) {
      // Create filterValueList from Product Filters
      //if (this.productNameInput) {
      //  this.productFilters.productName = this.productFilters.productName + this.productNameInput + ',';
      //  this.productNameInput = '';
      //}
      if (this.selectedValue != 'Change Since' && !this.retainChangeSince) {
        this.priceListFilter.changeSinceDate = null;
      }
      this.filterValueList = [];
      if (this.productFilters) {
        this.filter.productName = this.matChipDisplay('Product Name', this.productFilters.productName);
        this.productFilters.productNumber = this.matChipListDisplay('Product Number', this.priceListFilter.productNumber, this.productFilters.productNumber) || [];
        this.productFilters.productLine = this.matChipListDisplay('Product Line', this.priceListFilter.productLine, this.productFilters.productLine) || [];
        this.productFilters.packageSize = this.matChipListDisplay('Pack Size', this.priceListFilter.packageSize, this.productFilters.packageSize) || [];
        this.productFilters.productCategory = this.matChipListDisplay('Product Category', this.priceListFilter.productCategory, this.productFilters.productCategory) || [];
        this.productFilters.supplier = this.matChipListDisplay('Supplier', this.priceListFilter.supplier, this.productFilters.supplier) || [];
        this.productFilters.changeSinceDate = this.matChipDisplay('Change Since', this.priceListFilter.changeSinceDate);
        this.productFilters.productBrand = this.matChipListDisplay('Product Brand', this.priceListFilter.productBrand, this.productFilters.productBrand) || [];
      }
      if (this.filterValueList.length > 8) {
        this.displayHideAll = true;
        this.disableFilterBtn = false;
      } else {
        this.displayHideAll = false;
        this.disableFilterBtn = true;
      }

      if (this.filterValueList.length > 0) {
        this.disableFilterBtn = false;
      } else {
        this.disableFilterBtn = true;
      }
    }
  }

  updatedVal(e) {
    this.productFilters.productName = (e || '').trim();
    this.validateProductSearch(this.productFilters.productName);
  }

  validateProductSearch(toValidateInput: any) {
    // To Validate Brand
    if ((toValidateInput !== null && toValidateInput !== '' && toValidateInput.toString().trim().length >= 3)
      || this.productFilters.productName !== null && this.productFilters.productName !== '' && this.productFilters.productName.toString().trim().length >= 3
    ) {
      this.disableFilterBtn = false;
    }
    else {
      this.disableFilterBtn = true;
    }
  }

  validateBrand(e) {
    e = (e || '').trim();
    if (e !== null && e !== '' && e.length > 2) {
      this.productFilters.productName = e;
      this.disableFilterBtn = false;
    } else {
      this.disableFilterBtn = true;
      this.productFilters.productName = '';
    }
  }

  setChangeSinceDate() {
    if (this.selectedValue == 'Change Since') {
      if (this.priceListFilter.changeSinceDate == null) {
        this.priceListFilter.changeSinceDate = this.lastSaturday;
      }
    }
    else {
      if (!this.retainChangeSince) {
        this.priceListFilter.changeSinceDate = null;
      }
    }
  }

  // Display text on MatChip for text filter
  matChipDisplay(label, property): string {
    if (property) {
      if (label == 'Change Since') {
        this.filterValueList.push(label + ' : ' + this.datePipe.transform(this.priceListFilter.changeSinceDate, 'MM/dd/yyyy'));
      }
      else {
        const productNames = property.trim().split(',');
        if (productNames && productNames.length > 0) {
          productNames.forEach(x => {
            if (x) { this.filterValueList.push(label + ' : ' + x); }
          });
        } else {
          this.filterValueList.push(label + ' : ' + property);
        }
      }
    }
    return property;
  }
  // Display text on MatChip for dropdown filter
  matChipListDisplay(lable, list, propertyList) {
    if (propertyList && propertyList.length > 0) {
      propertyList.forEach(x => {
        const productLine = list.find(y => y == x);
        if (productLine != undefined) {
          this.filterValueList.push(lable + ' : ' + x);
        }
      });
    }
    return propertyList;
  }
  // To view all the filters Applied
  viewAllFilter() {
    this.viewAllFilters = !this.viewAllFilters;
  }
  // To remove/clear selected chip search filter
  removeSelectedFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const removeFilterValue = removeFilter[1].trim();
    switch (removeFilter[0].trim()) {
      case 'Product Name':
        const names = this.productFilters.productName.split(',');
        for (let i = 0; i < names.length; i++) {
          if (names[i].trim() === removeFilterValue) {
            names.splice(i, 1); i--;
          }
        }
        this.productFilters.productName = names.join(',');
        break;
      case 'Product Number':
        this.productFilters.productNumber = this.productFilters.productNumber.filter(id => id.trim() !== removeFilterValue);
        break;
      case 'Product Line':
        this.productFilters.productLine = this.productFilters.productLine.filter(id => id.trim() !== removeFilterValue);
        break;
      case 'Pack Size':
        this.productFilters.packageSize = this.productFilters.packageSize.filter(id => id.trim() !== removeFilterValue);
        break;
      case 'Product Category':
        this.productFilters.productCategory = this.productFilters.productCategory.filter(id => id.trim() !== removeFilterValue);
        break;
      case 'Supplier':
        this.productFilters.supplier = this.productFilters.supplier.filter(id => id.trim() !== removeFilterValue);
        break;
      case 'Change Since':
        this.productFilters.changeSinceDate = null;
        this.priceListFilter.changeSinceDate = null;
        this.retainChangeSince = false;
        break;
      case 'Product Brand':
        this.productFilters.productBrand = this.productFilters.productBrand.filter(id => id.trim() !== removeFilterValue);
        break;
      default:
        break;
    }
  }
  // Clear all filter
  clearAllFilter() {
    this.filterValueList = new Array();
    this.displayHideAll = true;
    this.isShowChangesOnly = false;
    this.viewAllFilters = false;
    this.productFilters.changeSinceDate = null;
    this.priceListFilter.changeSinceDate = null;
    this.resetProductFilter();
    this.setPriceListTableHeight();
    this.getCPPProductData();
    this.viewAllFilters = false;
  }
  //Add or Remove Favorite Items
  AddFavorite() {
    let ItemIds: any = [];

    this.cppProductListDataSource.data.filter(x => x.isSelected === true).forEach(x => {
      if (x.itemId !== null) {
        ItemIds.push(x.itemId);
      }
    });
    const favoriteFilter = {
      itemIds: ItemIds,
      Active: true
    };

    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppPriceListService.addRemoveItemFavoriteItems(favoriteFilter).subscribe(result => {
      if (result) {
        this.getCPPProductData();
      } error => {
        this.loaderService.setLoaderStatus(false);
        LolLoggerService.error(error);
      }
    }));
  }

  RemoveFavorite() {
    let ItemIds: any = [];

    this.cppProductListDataSource.data.filter(x => x.isSelected === true).forEach(x => {
      if (x.itemId !== null) {
        ItemIds.push(x.itemId);
      }
    });
    const favoriteFilter = {
      itemIds: ItemIds,
      Active: false
    };

    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppPriceListService.addRemoveItemFavoriteItems(favoriteFilter).subscribe(result => {
      if (result) {
        this.getCPPProductData();
      } error => {
        this.loaderService.setLoaderStatus(false);
        LolLoggerService.error(error);
      }
    }));
  }

  // on clicking individual star icon
  AddFavoriteIndividual(element) {
    let ItemIds: any = [];
    ItemIds.push(element.itemId);
    const favoriteFilter = {
      itemIds: ItemIds,
      Active: true
    };

    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppPriceListService.addRemoveItemFavoriteItems(favoriteFilter).subscribe(result => {
      if (result) {
        this.getCPPProductData();
      } error => {
        this.loaderService.setLoaderStatus(false);
        LolLoggerService.error(error);
      }
    }));
  }
  RemoveFavoriteIndividual(element) {
    let ItemIds: any = [];
    ItemIds.push(element.itemId);
    const favoriteFilter = {
      itemIds: ItemIds,
      Active: false
    };

    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppPriceListService.addRemoveItemFavoriteItems(favoriteFilter).subscribe(result => {
      if (result) {
        this.getCPPProductData();
      } error => {
        this.loaderService.setLoaderStatus(false);
        LolLoggerService.error(error);
      }
    }));
  }
  // Export the price list data of selected items
  exportData(aprView, isOwnerPricingAccess) {
    let itemId = '';
    this.cppProductListDataSource.data.filter(x => x.isSelected === true).forEach(x => {
      if (x.itemId !== null) {
        itemId = itemId + x.itemId + ',';
      }
    });

    if (this.priceListFilter.changeSinceDate != null) {
      if (this.isValidDate(this.datePipe.transform(this.priceListFilter.changeSinceDate, 'MM/dd/yyyy'))) {
        this.productFilters.changeSinceDate = new Date(this.productFilters.changeSinceDate).toDateString();
      }
      else {
        this.toastrService.error('Invalid Date Format.');
        this.loaderService.setLoaderStatus(false);
        return false;
      }
    }
    else {
      if (!this.isChangeSinceValid) {
        this.toastrService.error('Invalid Date Format.');
        this.loaderService.setLoaderStatus(false);
        return false;
      }
      this.productFilters.changeSinceDate = '01/01/1900';
    }

    const exportFilter = {
      companyCode: this.headerCompany,
      isAprView: aprView,
      IsOwnerPriceList: isOwnerPricingAccess,
      productName: this.filter.productName,
      accountNo: this.accountNo,
      itemIds: itemId,
      newPriceSince: new Date(this.productFilters.changeSinceDate).toDateString()
    };
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppPriceListService.exportCppPriceList(exportFilter).subscribe(result => {
      this.base64toFile(result.base64, result.mimeType, result.fileName);
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); LolLoggerService.info(error); }));
  }
  // Decode base64 to file
  base64toFile(base64String, contentType, fileName) {
    const blob = this.b64toBlob(base64String, contentType, 550);
    saveAs(blob, fileName);
  }
  // Convert b64 to BLOB
  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    b64Data = b64Data.replace(/\s/g, ''); // IE compatibility...
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  // Send price list in email
  emailData(aprView, isOwnerPricingAccess) {
    this.tabNode = this.tabNode ? false : true;
    let accountEmail = '';
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        accountEmail = data.resultData[0].emailId;
      }
    }

    if (this.priceListFilter.changeSinceDate != null) {
      if (this.isValidDate(this.datePipe.transform(this.priceListFilter.changeSinceDate, 'MM/dd/yyyy'))) {
        this.productFilters.changeSinceDate = new Date(this.productFilters.changeSinceDate).toDateString();
      }
      else {
        this.toastrService.error('Invalid Date Format.');
        this.loaderService.setLoaderStatus(false);
        return false;
      }
    }
    else {
      if (!this.isChangeSinceValid) {
        this.toastrService.error('Invalid Date Format.');
        this.loaderService.setLoaderStatus(false);
        return false;
      }
      this.productFilters.changeSinceDate = '01/01/1900';
    }

    const emailDialog = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: { email: accountEmail, title: 'Send Email', tabNode: this.tabNode, dialogType: 'email' }
    });
    this.subscription.push(emailDialog.afterClosed().subscribe(emailIds => {
      // If user selected Yes
      if (emailIds) {
        let itemId = '';
        this.cppProductListDataSource.data.filter(x => x.isSelected === true).forEach(x => {
          if (x.itemId !== null) {
            itemId = itemId + x.itemId + ',';
          }
        });
        const emailFilter = {
          companyCode: this.headerCompany,
          emailIds: emailIds,
          itemIds: itemId,
          isAprView: aprView,
          IsOwnerPriceList: isOwnerPricingAccess,
          accountNo: this.accountNo,
          newPriceSince: new Date(this.productFilters.changeSinceDate).toDateString()
        };

        this.loaderService.setLoaderStatus(true);
        this.subscription.push(this.cppPriceListService.emailCppProductList(emailFilter).subscribe(result => {
          if (result) { this.toastrService.success('Email sent'); }
          this.loaderService.setLoaderStatus(false);
        }, error => {
          this.loaderService.setLoaderStatus(false);
          LolLoggerService.error(error);
        }));
      }
      this.tabNode = false;
    }));
  }

  validateDateString(event) {
    const allowedRegex = /[0-9\/]/;
    if (!event.key.match(allowedRegex)) {
      event.preventDefault();
    }
  }

  isValidDate(dateString) {
    const regEx = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateString.match(regEx)) { return false; }  // Invalid format
    const d = new Date(dateString);
    const dNum = d.getTime();
    if (!dNum && dNum !== 0) { return false; } // NaN value, Invalid date
    return this.datePipe.transform(d, 'MM/dd/yyyy') === dateString;
  }

  getErrorMessage(value) {
    const regEx = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
    if (value != null && value != '') {
      if (!value.match(regEx)) {
        this.isChangeSinceValid = false;
      }
      else {
        this.isChangeSinceValid = true;
      }// Invalid format
    }
    else {
      this.isChangeSinceValid = true;
    }
  }

  // Redirect to Subscription page
  redirectToSubscription() {
    this.cppPriceListService.accountName = this.accountName;
    this.router.navigate(['/cpp/price-list-manage-subscription/' + this.accountNo]);
    this.setPriceListTableHeight();
  }

  // Show or hide Subscription Modal
  showHideSubscription() {
    this.isShowClick = true;
    this.isSubsModalShow = !this.isSubsModalShow;
    this.changesOnly = (this.isStatus == 'Unsubscribed' ? 'N' : this.changesOnly);
    this.subscriptionType = (this.isStatus == 'Unsubscribed' ? 'A' : this.subscriptionType);
    this.setTriToggleMySubscription();
  }

  // Get Subscription My Status
  getSubscriptionStatus() {
    this.subscription.push(this.cppManageSubscription.getSubscriptionStatus(this.accountNo).subscribe(result => {
      this.isStatus = result.status;
      this.changesOnly = result.changesOnly;
      this.displayAPR = result.aprFlag;
      this.getSubscriptionStatusWithChangeType(result.changeType);
      this.subscriptionType = result.subscriptionType;
      this.changesOnlyFlag = result.changesOnly;
      this.subscriptionTypeFlag = result.subscriptionType;
      this.isManageSubAccess = result.roleLevel > 1 ? true : false;
    }));
  }

  getSubscriptionStatusWithChangeType(type: string) {
    switch (type) {
      case 'Price':
        this.changesOnly = 'Y';
        this.pricechangesOnly = 'Y';
        this.termchangesOnly = 'N';
        break;
      case 'Term':
        this.changesOnly = 'Y';
        this.pricechangesOnly = 'N';
        this.termchangesOnly = 'Y';
        break;
      case 'Term Or Price':
        this.changesOnly = 'Y';
        this.pricechangesOnly = 'Y';
        this.termchangesOnly = 'Y';
        break;
      default:
        this.changesOnly = 'N';
        this.pricechangesOnly = 'N';
        this.termchangesOnly = 'N';
        break;
    }
  }

  // Change My Status for Subscription
  changeStatus(update: boolean = false) {
    if (this.termchangesOnly == 'N' && this.pricechangesOnly == 'N') {
      this.changesOnly == 'N';
    }
    this.isSubsModalShow = false;
    this.subscription.push(this.cppManageSubscription.updateStatus(this.accountNo, this.subscriptionType, this.changesOnly, this.displayAPR, this.changeType, update).subscribe(result => {
      if (result && result == true) {
        if (update == false) {
          this.isStatus = (this.isStatus == 'Subscribed' ? 'Unsubscribed' : 'Subscribed');
          this.changesOnly = (this.isStatus == 'Unsubscribed' ? 'N' : this.changesOnly);
          this.subscriptionType = (this.isStatus == 'Unsubscribed' ? 'A' : this.subscriptionType);
        }
        this.changesOnlyFlag = this.changesOnly;
        this.subscriptionTypeFlag = this.subscriptionType;
      }
      else {
        this.toastrService.error('Email address is required for subscription.');
      }
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Change the toggle value for Pop up
  toggleForSpecialItemDisplayPopup() {
    this.subscriptionType = this.subscriptionType == 'C' ? 'A' : 'C';
  }
  // Toggle for MySubscription
  changeForMySubscription() {
    if (this.mySubscriptionDisplayItemToggle == 'all') {
      this.mySubscriptionDisplayItemToggle = 'special';
      this.subscriptionType = 'C';
    } else if (this.mySubscriptionDisplayItemToggle == 'special') {
      this.mySubscriptionDisplayItemToggle = 'favorite';
      this.subscriptionType = 'F';
    } else if (this.mySubscriptionDisplayItemToggle == 'favorite') {
      this.mySubscriptionDisplayItemToggle = 'all';
      this.subscriptionType = 'A';
    }
    this.cd.detectChanges();
  }
  // Change the toggle value for Pop up
  toggleForDisplayAPRPopup() {
    this.displayAPR = this.displayAPR == 'Y' ? 'N' : 'Y';
  }
  // Change the toggle value for Pop up
  toggleForchangesOnlyPopup() {
    this.changesOnly = this.changesOnly == 'Y' ? 'N' : 'Y';
    if (this.changesOnly == 'N') {
      this.termchangesOnly = 'N';
      this.pricechangesOnly = 'N';
    }
    else {
      this.termchangesOnly = 'Y';
      this.pricechangesOnly = 'Y';
    }

    this.SetChangeType();
  }

  toggleForTermChangesOnly() {
    this.termchangesOnly = this.termchangesOnly == 'Y' ? 'N' : 'Y';
    if (this.termchangesOnly == 'N' && this.pricechangesOnly == 'N') {
      this.changesOnly = 'N';
      this.isShowClick = true;
    }
    this.SetChangeType();
  }

  toggleForPriceChangesOnlyPopup() {
    this.pricechangesOnly = this.pricechangesOnly == 'Y' ? 'N' : 'Y';
    if (this.termchangesOnly == 'N' && this.pricechangesOnly == 'N') {
      this.changesOnly = 'N';
      this.isShowClick = true;
    }
    this.SetChangeType();
  }

  SetChangeType() {
    if (this.termchangesOnly == 'Y' && this.pricechangesOnly == 'Y') {
      this.changeType = 'Term Or Price';
    }
    else if (this.termchangesOnly == 'Y' && this.pricechangesOnly == 'N') {
      this.changeType = 'Term';
    }
    else if (this.termchangesOnly == 'N' && this.pricechangesOnly == 'Y') {
      this.changeType = 'Price';
    }
    else {
      this.changeType = '';
    }
  }

  // Close the pop up on No action
  closePopup() {
    if (!this.isShowClick) {
      this.isSubsModalShow = false;
    }
    this.changesOnly = (this.isStatus == 'Unsubscribed' ? 'N' : this.changesOnlyFlag);
    this.subscriptionType = (this.isStatus == 'Unsubscribed' ? 'A' : this.subscriptionTypeFlag);
    this.isShowClick = false;
  }

  // Toggle for MySubscription
  setTriToggleMySubscription() {
    if (this.subscriptionType == 'C') {
      this.mySubscriptionDisplayItemToggle = 'special';
    } else if (this.subscriptionType == 'F') {
      this.mySubscriptionDisplayItemToggle = 'favorite';
    } else if (this.subscriptionType == 'A') {
      this.mySubscriptionDisplayItemToggle = 'all';
    }
    this.cd.detectChanges();
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
